/**
 * ⭐⭐⭐ **Menghitung tanggal usaha dari ATURANNYA** — dipakai klien saat portal tak terjangkau.
 *
 * ### ⛔ Ini bukan mengembalikan tebakan jam perangkat
 * Tanggal usaha = **zona waktu OUTLET** + **jam pergantian hari** (§2). Sebelum ini `pos-web`
 * memakai `new Date().toISOString().slice(0,10)` — tanggal UTC, yang di UTC+7 meleset satu hari
 * setiap pukul 00:00–07:00, dan sesi kas pukul 06:00 mendarat di hari kemarin.
 *
 * ⇒ Yang berubah: klien tak lagi MENEBAK, ia memegang **aturannya**. Selama zona & cutover datang
 *   dari server (`GET /outlets/:code/business-date`) dan tersimpan, jawabannya sama persis dengan
 *   yang dihitung Postgres — termasuk saat internet mati.
 *
 * ⚠️ Yang TETAP tak bisa dijawab luring: `dayClosed`. Itu fakta yang lahir dari settlement, dan
 * perangkat tak punya cara mengetahuinya tanpa bertanya. Klien wajib memperlakukan
 * "belum tahu" ≠ "belum ditutup".
 */
/**
 * Tanggal usaha menurut `rule`, pada saat `now`.
 *
 * ⚠️ Zona dihitung lewat `Intl` (`en-CA` menghasilkan `YYYY-MM-DD`), bukan dengan menggeser jam
 * secara manual: offset zona berubah karena DST dan karena keputusan pemerintah, dan aritmetika
 * offset yang ditulis tangan akan salah pada hari-hari itu saja — persis hari yang paling sulit
 * dicurigai.
 */
export function businessDateFromRule(rule, now = new Date()) {
    const [jam = '0', menit = '0'] = rule.cutoverTime.split(':');
    const cutoverMs = (Number(jam) * 60 + Number(menit)) * 60_000;
    /*
     * Waktu lokal outlet DIKURANGI jam pergantian hari, lalu diambil tanggalnya. Pukul 01:30 dengan
     * cutover 04:00 menghasilkan 21:30 hari sebelumnya ⇒ tanggalnya KEMARIN. Rumus yang sama persis
     * dengan kueri `currentBusinessDate` di `pos-core`.
     */
    const lokalMs = new Date(new Intl.DateTimeFormat('sv-SE', {
        timeZone: rule.timezone,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
    }).format(now).replace(' ', 'T') + 'Z').getTime();
    return new Intl.DateTimeFormat('en-CA', { timeZone: 'UTC' }).format(new Date(lokalMs - cutoverMs));
}
//# sourceMappingURL=business-date.js.map